import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'survey.title',
		'defaultMessage': 'Stog Feedback',
	},
	subtitle: {
		'id': 'survey.subtitle',
		'defaultMessage':'If you use our platform in any way - please give us your feedback.</br>We value all data we can get to grow smarter. '
	},
	button: {
		'id': 'survey.button',
		'defaultMessage': 'pass a survey',
	},

});




// WEBPACK FOOTER //
// ./src/components/LandingSurvey/messages.js